import React from 'react';
import { Target, Award, Users, TrendingUp } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: Target,
      title: "Misión",
      description: "Proporcionar soluciones integrales de seguridad contra incendios con tecnología de vanguardia y personal altamente capacitado."
    },
    {
      icon: Award,
      title: "Excelencia",
      description: "Compromiso con la calidad y cumplimiento de las normativas internacionales en todos nuestros servicios y productos."
    },
    {
      icon: Users,
      title: "Experiencia",
      description: "Más de 10 años protegiendo empresas, instituciones y hogares con soluciones personalizadas."
    },
    {
      icon: TrendingUp,
      title: "Innovación",
      description: "Constantemente actualizamos nuestros equipos y conocimientos para ofrecer las mejores soluciones del mercado."
    }
  ];

  return (
    <section id="nosotros" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Contenido texto */}
          <div>
            <div className="inline-block mb-4">
              <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider bg-orange-100 px-4 py-2 rounded-full">
                Sobre Nosotros
              </span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Líderes en Seguridad 
              <span className="text-orange-600"> Contra Incendios</span>
            </h2>

            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              <strong>Adriana Calero Seguridad Contra Incendios</strong> es una empresa 
              especializada en la protección y prevención de incendios, ofreciendo soluciones 
              integrales que van desde la venta e instalación de equipos hasta capacitaciones.
            </p>

            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
             Contamos con un equipo comprometido con la seguridad y la calidad en cada servicio.
            Ofrecemos soluciones integrales en seguridad contra incendios, con atención oportuna, acompañamiento profesional y enfoque en la protección de vidas y patrimonio.
            </p>

            <div className="grid sm:grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <div className="bg-orange-100 p-2 rounded-lg mt-1">
                  <Award className="text-orange-600" size={24} />
                </div>
               <div>
  <h3 className="font-bold text-gray-900 mb-1">Atención Personalizada</h3>
  <p className="text-gray-600 text-sm">Asesoría profesional en seguridad contra incendios</p>
</div>
              </div>
              <div className="flex items-start gap-3">
                <div className="bg-orange-100 p-2 rounded-lg mt-1">
                  <Users className="text-orange-600" size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Personal Experto</h3>
                  <p className="text-gray-600 text-sm">Técnicos certificados</p>
                </div>
              </div>
            </div>
          </div>

          {/* Imagen y valores */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl mb-8">
              <img
                src="/nosotros.jpg"                alt="Equipo de trabajo"
                className="w-full h-[400px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6 text-white">
                <p className="text-lg font-medium">Protegiendo vidas y sus patrimonios </p>
              </div>
            </div>

            {/* Grid de valores */}
            <div className="grid grid-cols-2 gap-4">
              {values.map((value, index) => (
                <div
                  key={index}
                  className="bg-white p-5 rounded-xl shadow-md hover:shadow-xl transition-all cursor-default border border-gray-100"
                >
                  <div className="bg-orange-100 w-12 h-12 rounded-lg flex items-center justify-center mb-3">
                    <value.icon className="text-orange-600" size={24} />
                  </div>
                  <h3 className="font-bold text-gray-900 mb-2">{value.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
